import { render } from "./addWeighingDialog.vue?vue&type=template&id=151d4738&scoped=true"
import script from "./addWeighingDialog.vue?vue&type=script&lang=js"
export * from "./addWeighingDialog.vue?vue&type=script&lang=js"

import "./addWeighingDialog.vue?vue&type=style&index=0&id=151d4738&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151d4738"]])

export default __exports__